<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>icons / 20x20 / caret-down</title>
    <g
      id="icons-/-20x20-/-caret-down"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline
        id="Stroke-2"
        stroke="#97ABBE"
        stroke-width="2"
        points="5.0503 7.5253 10.0003 12.4753 14.9493 7.5253"
      ></polyline>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon"
};
</script>